if($('.carousel').length){
    $(document).ready(function(){  
        var myCarousels = $(".carousel");
        myCarousels.each(function( index, element  ) {
          var myCarousel = $("#"+$(element).attr('id')); 
          myCarousel.append("<ol class='carousel-indicators'></ol>");
          var indicators = $("#"+$(element).attr('id') + " .carousel-indicators"); 
          $("#"+$(element).attr('id') +" .carousel-inner").children(".item").each(function(index) {
              (index === 0) ? 
              indicators.append("<li data-target='#"+$(element).attr('id')+"' data-slide-to='"+index+"' class='active'></li>") : 
              indicators.append("<li data-target='#"+$(element).attr('id')+"' data-slide-to='"+index+"'></li>");
          });
        });
    });
}


if($('.blogFeeds').length){
    var storedNewsItems = sessionStorage.getItem('blogFeeds-'+document.location.host);
    if (storedNewsItems) {
        var newsItems = JSON.parse(storedNewsItems);
        displayNews(newsItems);
        
    } else {
        loadNewsFromURL();
    }

    function loadNewsFromURL() {
        var url = "/blog-novinky/";
        $.get(url, function(data) {
        var $data = $(data);
        var $newsItems = $data.find("#newsWrapper .news-item").slice(0, 4);
        var newsItemHTML = $newsItems.map(function() {
            return $(this)[0].outerHTML;
        }).get();
        sessionStorage.setItem('blogFeeds-'+document.location.host, JSON.stringify(newsItemHTML));
        displayNews(newsItemHTML);
        });
    }
    function displayNews(newsItems) {
        $(".blogFeeds .inner").empty().append(newsItems);
        $('.blogFeeds .inner .news-item img').each(function(){
            $(this).attr('src', $(this).attr('data-src'));
           // $(this).closest('.news-item').find('.text').append('<a href="'+$(this).closest('.news-item').find('.title').attr('href')+'" class="readMore">Přečíst článek</a>')
        })
    }
}


if($('.welcome>div>p img[style="float: left;"]').length){
    $('.welcome').before($('.welcome>div>p img[style="float: left;"]').closest('p'))
}